<template>
  <div id="app">
    <Header ref="headRef"></Header>
    <router-view />
    <Footer @callBack="callBack"></Footer>
    <GoTop></GoTop>
  </div>
</template>

<script>
export default {
  name: "App",
  mounted() {
    let goUrl = this.isMobile();
    if (goUrl === 1) {
      //移动端地址
      location = "http://syybkj.cn/wap";
    }
    // this.menuSeen()
    // window.addEventListener('scroll', this.handleScroll)
  },
  methods: {
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      // localStorage.setItem('isiphone',flag)
      // localStorage.setItem('ismobile', flag ? 1 : 0);
      let goUrl = flag ? 1 : 0;
      return goUrl;
    },
    callBack(index) {
      console.log(index, "回调");
      this.$nextTick(() => {
        this.$refs.headRef.initIndex(index);
      });
    }
  }
};
</script>

<style>
/* CSS Document */

* {
  margin: 0 auto;
  padding: 0px;
}
html {
  text-align: center;
}
a {
  text-decoration: none;
  color: #000;
}
img {
  border: 0px;
}
ul {
  list-style: none;
  padding: 0px;
}
body {
  font-family: "微软雅黑";
  color: #333;
  font-size: 12px !important;
  text-align: center;
}

.top {
  width: 100%;
  height: auto;
  float: left;
  background: url(./assets/images/top_02.gif) center repeat-x;
}
.top_cen {
  width: 1200px;
  height: 120px;
  background: #fff;
}
.logo {
  width: 454px;
  height: 92px;
  float: left;
  margin-top: 17px;
  margin-left: 10px;
}
.top_right {
  width: 215px;
  height: 120px;
  float: right;
}
.tel {
  width: 215px;
  height: 49px;
  float: right;
  margin-right: 10px;
  margin-top: 20px;
}
.ser {
  width: 212px;
  height: 30px;
  border: 1px solid #cecece;
  background: #fff;
  border-radius: 30px;
  margin: 3px 0px;
  float: right;
}
.wenben {
  width: 160px;
  height: 28px;
  border: 0px;
  background: #fff;
  color: #828282;
  margin-left: 11px;
  float: left;
  outline: none;
}
.tijiao {
  background: url(./assets/images/ser.gif) no-repeat;
  width: 16px;
  height: 16px;
  border: 0px;
  outline: none;
  margin: 4px 10px;
  margin-top: 7px;
  cursor: pointer;
  float: left;
}
.meu {
  width: 100%;
  height: 69px;
  float: left;
  background: url(./assets/images/meu.gif) repeat-x;
}
.meu_cen {
  width: 1200px;
  height: 44px;
}
.banner {
  float: left;
  width: 100%;
}
.bodyy {
  width: 100%;
  height: auto;
  float: left;
}
.bodyy_cen {
  width: 1200px;
  height: auto;
}
.bodyy_1 {
  width: 1200px;
  height: 252px;
  /* float: left; */
  margin-top: 10px;
}
.gsjj {
  width: 595px;
  height: 252px;
  float: left;
  text-align: left;
  border: 1px #d4d4d4 double;
}
.gsjj_tit {
  width: 593px;
  height: 35px;
  float: left;
  background: url(./assets/images/background.gif) repeat-x center;
  margin-left: 1px;
  margin-top: 1px;
}
.gsjj_tit_zi {
  width: 109px;
  height: 30px;
  float: left;
  text-align: left;
  background: url(./assets/images/blue.png) center no-repeat;
  margin-top: 1px;
  margin-left: 1px;
}
.gsjj_tit_zi a {
  width: 109px;
  height: 30px;
  display: block;
  text-align: center;
  font-size: 16px;
  color: #fff;
  line-height: 30px;
}
.gsjj_tit_more {
  width: 50px;
  height: 30px;
  float: right;
  text-align: right;
  margin-right: 10px;
  margin-top: 2px;
}
.gsjj_tit_more a {
  width: 50px;
  height: 30px;
  display: block;
  text-align: right;
  color: #666;
  line-height: 30px;
}
.gsjj_main {
  width: 593px;
  height: 216px;
  float: left;
}
.gsjj_pic {
  width: 284px;
  height: 192px;
  float: left;
  text-align: left;
  margin-top: 16px;
  margin-left: 10px;
}
.gsjj_world {
  width: 271px;
  height: 192px;
  float: left;
  text-align: left;
  margin-top: 16px;
  margin-left: 20px;
}
.gsjj_world_tit {
  width: 271px;
  height: 34px;
  float: left;
  text-align: center;
}
.gsjj_world_tit a {
  width: 271px;
  height: 34px;
  line-height: 34px;
  font-size: 16px;
  font-family: "宋体";
  font-weight: bold;
  text-align: center;
}
.gsjj_world_zi {
  width: 271px;
  height: 158px;
  float: left;
  text-align: left;
  overflow: hidden;
}
.gsjj_world_zi a {
  width: 271px;
  height: 158px;
  text-align: left;
  text-indent: 28px;
  font-family: "宋体";
  line-height: 30px;
}
.ggtz {
  width: 595px;
  height: 252px;
  float: left;
  text-align: left;
  border: 1px #d4d4d4 double;
  margin-left: 6px;
}
.ggtz_tit_zi {
  width: 593px;
  height: 35px;
  float: left;
  background: url(./assets/images/background.gif) repeat-x center;
  margin-left: 1px;
  margin-top: 1px;
}
.ggtz_tit_zi ul {
  width: 436px;
  height: 30px;
  float: left;
}
.ggtz_tit_zi li {
  width: 109px;
  height: 30px;
  float: left;
}
.ggtz_tit_zi li a {
  width: 109px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  font-size: 16px;
  font-family: "宋体";
  font-weight: bold;
  color: #005bbf;
  display: block;
}
.ggtz_tit_zi li:hover {
  background: url(./assets/images/blue.png) center no-repeat;
}
.ggtz_tit_zi li a:hover {
  color: #fff;
}
.thistab {
  background: url(./assets/images/blue.png) center no-repeat;
}
.thistab a {
  color: #fff !important;
}
.tab_con {
  width: 577px;
  height: 198px;
  float: left;
  margin-left: 6px;
  margin-top: 10px;
}
.tab_con dl {
  width: 577px;
  height: 198px;
  float: left;
  overflow: hidden;
}
.tab_con dd {
  width: 577px;
  height: 33px;
  float: left;
  border-bottom: 1px dashed #aeabab;
}
.sanjiao {
  width: 5px;
  height: 8px;
  float: left;
  text-align: left;
  margin-left: 5px;
  margin-top: 12px;
}
.biaoti {
  width: 462px;
  height: 33px;
  float: left;
  text-align: left;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-left: 8px;
}
.biaoti a {
  width: 462px;
  height: 33px;
  text-align: left;
  font-size: 14px;
  font-family: "宋体";
  line-height: 33px;
}
.date {
  width: 80px;
  height: 33px;
  float: right;
  text-align: right;
}
.date a {
  width: 80px;
  height: 33px;
  text-align: right;
  font-size: 12px;
  font-family: "宋体";
  line-height: 33px;
  color: #999;
}
.biaoti a:hover {
  color: #005bbf;
}
.bodyy_2 {
  width: 1200px;
  height: 129px;
  /* float: left; */
  margin-top: 10px;
}
.zxfu {
  width: 1198px;
  height: 129px;
  float: left;
  text-align: left;
  border: 1px #d4d4d4 double;
}
.zxfu_tit {
  width: 1197px;
  height: 35px;
  float: left;
  background: url(./assets/images/background.gif) repeat-x center;
  margin-left: 1px;
  margin-top: 1px;
}
.zxfu_main {
  width: 188px;
  height: 75px;
  float: left;
}
.zxfu_main ul {
  width: 1197px;
  height: 75px;
  float: left;
}
.zxfu_main li {
  width: 185px;
  height: 75px;
  float: left;
  margin-left: 13px;
}

.zxfu_main2 {
  width: 188px;
  height: 75px;
  float: left;
}
.zxfu_main2 ul {
  width: 390px;
  height: 75px;
  float: left;
}
.zxfu_main2 li {
  width: 185px;
  height: 75px;
  float: left;
  margin-left: 10px;
}
.jszd {
  width: 185px;
  height: 75px;
  float: left;
  background: #d00000;
  border-radius: 6px;
  margin-top: 10px;
}
.jszd a {
  width: 70px;
  height: 70px;
  display: block;
  float: left;
  text-align: center;
  margin-left: 10px;
  margin-top: 4px;
}
.jszd_zi {
  width: 66px;
  height: 20px;
  float: right;
  text-align: right;
  margin-right: 34px;
  margin-top: 10px;
}
.jszd_zi a {
  width: 66px;
  height: 20px;
  display: block;
  text-align: center;
  color: #fff;
  font-size: 16px;
  font-weight: bold;
  line-height: 24px;
}
.dbsb {
  width: 185px;
  height: 75px;
  float: left;
  background: #ec9013;
  border-radius: 6px;
  margin-top: 10px;
}
.rypx {
  width: 185px;
  height: 75px;
  float: left;
  background: #0d69c5;
  border-radius: 6px;
  margin-top: 10px;
}
.wlxs {
  width: 185px;
  height: 75px;
  float: left;
  background: #05aa47;
  border-radius: 6px;
  margin-top: 10px;
}
.dbsb a {
  width: 70px;
  height: 70px;
  display: block;
  float: left;
  text-align: center;
  margin-left: 10px;
  margin-top: 4px;
}
.dbsb_zi {
  width: 66px;
  height: 20px;
  float: right;
  text-align: right;
  margin-right: 34px;
  margin-top: 20px;
}
.dbsb_zi a {
  width: 66px;
  height: 20px;
  display: block;
  text-align: right;
  color: #fff;
  font-size: 16px;
  font-weight: bold;
  line-height: 24px;
}
.rypx a {
  width: 70px;
  height: 70px;
  display: block;
  float: left;
  text-align: center;
  margin-left: 10px;
  margin-top: 4px;
}
.rypx_zi {
  width: 66px;
  height: 20px;
  float: right;
  text-align: right;
  margin-right: 34px;
  margin-top: 20px;
}
.rypx_zi a {
  width: 66px;
  height: 20px;
  display: block;
  text-align: right;
  color: #fff;
  font-size: 16px;
  font-weight: bold;
  line-height: 24px;
}
.wlxs a {
  width: 70px;
  height: 70px;
  display: block;
  float: left;
  text-align: center;
  margin-left: 10px;
  margin-top: 4px;
}
.wlxs_zi {
  width: 66px;
  height: 20px;
  float: right;
  text-align: right;
  margin-right: 34px;
  margin-top: 20px;
}
.wlxs_zi a {
  width: 66px;
  height: 20px;
  display: block;
  text-align: right;
  color: #fff;
  font-size: 16px;
  font-weight: bold;
  line-height: 24px;
}
.rlzy {
  width: 400px;
  height: 129px;
  float: left;
  text-align: left;
  border: 1px #d4d4d4 double;
  margin-left: 6px;
}
.rlzy_tit {
  width: 398px;
  height: 35px;
  float: left;
  background: url(./assets/images/background.gif) repeat-x center;
  margin-left: 1px;
  margin-top: 1px;
}
.zxzp {
  width: 185px;
  height: 75px;
  float: left;
  background: #f57167;
  border-radius: 6px;
  margin-top: 10px;
}
.zxzp a {
  width: 70px;
  height: 70px;
  display: block;
  float: left;
  text-align: center;
  margin-left: 10px;
  margin-top: 4px;
}
.yrln {
  width: 185px;
  height: 75px;
  float: left;
  background: #35ade5;
  border-radius: 6px;
  margin-top: 10px;
}
.yrln a {
  width: 70px;
  height: 70px;
  display: block;
  float: left;
  text-align: center;
  margin-left: 10px;
  margin-top: 4px;
}
.bodyy_3 {
  width: 1200px;
  height: 220px;
  /* float: left; */
  border: 1px #d4d4d4 double;
  margin-top: 10px;
}
.cpzs {
  width: 30px;
  height: 168px;
  float: left;
  background: url(./assets/images/blue_shu.png) no-repeat center;
  margin-left: 4px;
  margin-top: 26px;
}
.cpzs a {
  width: 30px;
  height: 80px;
  font-size: 16px;
  color: #fff;
  display: block;
  margin-top: 38px;
}
.liebiao {
  width: 1160px;
  height: 200px;
  float: left;
}

.cpzs_tu {
  width: 203px;
  height: 153px;
  float: left;
  border: 1px #d4d4d4 double;
}
.cpzs_zi {
  width: 203px;
  height: 35px;
  float: left;
  overflow: hidden;
  text-align: center;
}
.cpzs_zi a {
  width: 203px;
  height: 35px;
  text-align: center;
  font-size: 14px;
  font-family: "宋体";
  line-height: 35px;
  margin-top: 5px;
}
.jiantou_r {
  width: 24px;
  height: 34px;
  float: right;
  text-align: right;
  margin-top: 74px;
  margin-right: 5px;
}
.bodyy_4 {
  width: 1200px;
  height: 220px;
  /* float: left; */
  margin-top: 10px;
  margin-bottom: 20px;
}
.liebiao1 {
  width: 710px;
  height: 200px;
  float: left;
}
.jiantou_c1 {
  width: 710px;
  height: 200px;
  float: left;
  overflow: hidden;
  margin-left: 5px;
}
.jiantou_c1 ul {
  width: 710px;
  height: 200px;
  float: left;
  margin-top: 22px;
}
.jiantou_c1 li {
}

.box1 {
  float: left;
  width: 1160px;
  height: 200px;
  display: flex;
  margin-top: 22px;
}
.floatL {
  float: left;
  display: inline;
  width: 24px;
  height: 34px;
  text-align: left;
  margin: 0px 5px;
  margin-top: 70px;
}
.subBox {
  width: 1080px;
  overflow: hidden;
  /* display: inline;
  float: left; */
  margin: 0 auto;
}
.subBox ul {
  /* width: 100000px; */
  list-style: none;
  padding: 0;
  margin: 0 auto;
  display: flex;
}
.subBox ul li {
  width: 203px;
  height: 200px;
  /* float: left; */
  margin: 0 7px;
  text-align: center;
  /* display: inline; */
}

.box2 {
  float: left;
  width: 710px;
  height: 200px;
  display: flex;
  margin-top: 22px;
}
.floatL2 {
  float: left;
  display: inline;
  width: 24px;
  height: 34px;
  text-align: left;
  margin: 0px 5px;
  margin-top: 70px;
}
.subBox2 {
  width: 642px;
  overflow: hidden;
  /* display: inline;
  float: left; */
}
.subBox2 ul {
  list-style: none;
  padding: 0;
  margin: 0 auto;
  display: flex;
}
.subBox2 ul li {
  width: 203px;
  height: 200px;
  /* float: left; */
  margin: 0 5px;
  text-align: center;
  /* display: inline; */
}
.cgal {
  width: 756px;
  height: 220px;
  float: left;
  border: 1px #d4d4d4 double;
}
.lxwm {
  width: 430px;
  height: 220px;
  float: left;
  text-align: left;
  border: 1px #d4d4d4 double;
  margin-left: 10px;
}
.lxwm_tit {
  width: 428px;
  height: 35px;
  float: left;
  background: url(./assets/images/background.gif) repeat-x center;
  margin-left: 1px;
  margin-top: 1px;
}
.lxwm_main {
  width: 413px;
  height: 166px;
  float: left;
  margin: 8px 8px;
  background: url(./assets/images/lxwm.gif) no-repeat center;
}
.lxwm_s {
  width: 246px;
  height: 48px;
  float: left;
  margin-left: 20px;
  margin-top: 3px;
}
.lxwm_s_l {
  width: 44px;
  height: 48px;
  float: left;
  text-align: left;
  overflow: hidden;
}
.lxwm_s_l a {
  width: 44px;
  height: 48px;
  text-align: left;
  font-size: 16px;
  font-family: "宋体";
  line-height: 24px;
}
.lxwm_s_r {
  width: 202px;
  height: 48px;
  float: left;
  text-align: left;
  overflow: hidden;
}
.lxwm_s_r a {
  width: 202px;
  height: 48px;
  text-align: left;
  font-size: 16px;
  font-family: "宋体";
  line-height: 24px;
}
.foot {
  width: 100%;
  height: auto;
  float: left;
  border-top: 5px solid #005bbf;
}
.foot_c {
  width: 1200px;
  height: 100px;
}
.logo_f {
  width: 318px;
  height: 68px;
  float: left;
  text-align: left;
  margin-left: 10px;
  margin-top: 18px;
}
.foot_z {
  width: 732px;
  height: 53px;
  float: right;
  text-align: right;
  font-family: "宋体";
  line-height: 20px;
  margin-top: 30px;
}

.about_cen {
  width: 1200px;
  height: auto;
}
.about_l {
  width: 255px;
  height: auto;
  float: left;
  margin-top: 20px;
}
.about_list {
  width: 249px;
  height: auto;
  float: left;
  margin-bottom: 10px;
}
.about_tit {
  width: 249px;
  height: 49px;
  float: left;
  background: url(./assets/images/list.png) no-repeat center;
}
.about_tit a {
  width: 249px;
  height: 49px;
  display: block;
  font-size: 18px;
  font-weight: bold;
  color: #fff;
  line-height: 42px;
}
.about_lie {
  width: 246px;
  height: auto;
  float: left;
  margin-left: 3px;
}
.about_lie ul {
  width: 246px;
  height: auto;
  float: left;
}
.about_lie li {
  width: 246px;
  height: 46px;
  float: left;
  border-bottom: 1px solid #bdbdbd;
}
.about_lie_san {
  width: 5px;
  height: 8px;
  float: left;
  margin-left: 10px;
  margin-top: 20px;
}
.about_lie_zi {
  width: 212px;
  height: 46px;
  float: left;
  text-align: center;
  overflow: hidden;
}
.about_lie_zi a {
  width: 212px;
  height: 46px;
  display: block;
  text-align: center;
  font-size: 16px;
  line-height: 46px;
}
.about_lie_zi a:hover {
  color: #005bbf;
}
.about_tu {
  width: 252px;
  height: 184px;
  float: left;
  margin-bottom: 10px;
}
.about_tu1 {
  width: 252px;
  height: 92px;
  float: left;
}
.about_tu2 {
  width: 252px;
  height: 92px;
  float: left;
}
.about_r {
  width: 934px;
  height: auto;
  float: left;
  margin-top: 20px;
  margin-left: 10px;
}
.dingwei {
  width: 934px;
  height: 39px;
  float: right;
  text-align: right;
  border-bottom: 1px solid #bdbdbd;
}
.dingwei a {
  text-align: right;
  font-family: "宋体";
  line-height: 44px;
}
.dingwei a:hover {
  color: #005bbf;
}
.about_main {
  width: 934px;
  height: auto;
  min-height: 700px;
  text-align: left;
  font-size: 18px;
  font-family: "宋体";
  line-height: 36px;
  text-indent: 0px;
  margin-top: 60px;
  margin-bottom: 20px;
}
.xinwen_tit {
  width: 934px;
  height: auto;
  float: left;
  margin-top: 20px;
  text-align: center;
}
.xinwen_biaoti {
  width: 900px;
  height: auto;
  float: left;
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  font-family: "宋体";
  line-height: 30px;
  color: #005bbf;
  margin-left: 20px;
}
.xinwen_riqi {
  width: 900px;
  height: 34px;
  float: left;
  text-align: center;
  font-size: 14px;
  font-family: "宋体";
  line-height: 34px;
  color: #005bbf;
  border-bottom: 1px solid #bdbdbd;
  margin-left: 20px;
  margin-top: 10px;
}
.about_main1 {
  width: 900px;
  height: auto;
  min-height: 700px;
  text-align: left;
  font-size: 18px;
  font-family: "宋体";
  line-height: 36px;
  text-indent: 0px;
  margin-top: 60px;
  margin-bottom: 20px;
  margin-left: 20px;
  display: block;
}

.new_list {
  width: 900px;
  height: auto;
  max-height: 1000px;
  min-height: 700px;
  text-align: left;
  margin-top: 60px;
  margin-bottom: 10px;
  margin-left: 20px;
  display: block;
  overflow: hidden;
}
.new_list ul {
  width: 900px;
  height: auto;
  max-height: 1000px;
  min-height: 700px;
  text-align: left;
}
.new_list li {
  width: 900px;
  height: 40px;
  text-align: left;
  border-bottom: 1px #bdbdbd dashed;
}
.fenye {
  width: 100%;
  float: left;
  height: 44px;
  display: block;
  text-align: center;
  margin-bottom: 20px;
  margin-top: 20px;
}
.zuo {
  width: 5px;
  height: 8px;
  float: left;
  margin-left: 5px;
  margin-top: 15px;
}
.zhong {
  width: 780px;
  height: 40px;
  float: left;
  text-align: left;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-left: 10px;
}
.zhong a {
  width: 780px;
  height: 40px;
  text-align: left;
  font-size: 18px;
  font-family: "宋体";
  line-height: 40px;
}
.you {
  width: 90px;
  height: 40px;
  float: right;
  text-align: right;
}
.you a {
  width: 90px;
  height: 40px;
  text-align: right;
  font-size: 16px;
  font-family: "宋体";
  line-height: 38px;
}
.zhong a:hover {
  color: #005bbf;
}

.pro_list {
  width: 900px;
  height: auto;
  float: left;
  min-height: 700px;
  text-align: left;
  margin-top: 20px;
  margin-bottom: 10px;
  margin-left: 20px;
  display: block;
  overflow: hidden;
}
.pro_list ul {
  width: 900px;
  height: auto;
  min-height: 700px;
  text-align: left;
  float: left;
}
.pro_list li {
  width: 273px;
  height: 270px;
  float: left;
  margin-left: 20px;
}
.pro_main {
  width: 273px;
  height: 270px;
  text-align: left;
  float: left;
}
.pro_tu {
  width: 271px;
  height: 204px;
  float: left;
  border: 1px #bdbdbd double;
}
.pro_zi {
  width: 273px;
  height: 50px;
  float: left;
  text-align: center;
  overflow: hidden;
}
.pro_zi a {
  width: 273px;
  height: 50px;
  text-align: center;
  font-size: 18px;
  font-family: "宋体";
  line-height: 30px;
}
.sj {
  float: left;
  width: 100%;
  min-height: 200px;
}
.sj dt {
  height: 40px;
  line-height: 40px;
  background: #0b53a7;
  color: #fff;
}
.k1,
.k2,
.k3,
.k4,
.k5,
.k6 {
  width: 16.66%;
  text-align: center;
  float: left;
}
.sj dd {
  height: 30px;
  line-height: 30px;
  width: 100%;
  float: left;
  font-size: 14px;
}
.sj dd:nth-child(odd) {
  background: #f1f1f1;
}
.cxtj {
  float: left;
  width: 100%;
  height: 30px;
  line-height: 30px;
  background: #0b53a7;
  color: #fff;
  font-size: 14px;
  text-indent: 1em;
}
.sousuox {
  width: 100%;
  height: 160px;
  background: #f1f1f1;
}
.so {
  width: 64%;
  margin: 45px 10%;
  height: 40px;
  float: left;
  margin-right: 20px;
  font-size: 14px;
  text-indent: 2em;
}
.tj {
  float: left;
  width: 140px;
  height: 40px;
  background: #0b53a7;
  color: #fff;
  border: 0px;
  margin-top: 45px;
  font-size: 16px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/App.vue